import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

// Services
import { SpinnerService } from '@app/core/services/root';

@Injectable({
    providedIn: 'root'
})
export class SpinnerInterceptorService implements HttpInterceptor {
    constructor(
        private spinnerService: SpinnerService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.startsWith('api/') || req.url.startsWith('auth/')) {
            this.showLoader(req.reportProgress);
        }
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {
                this.onEnd();
                return throwError(error);
            }),
            tap((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    this.onEnd();
                }
            },
            (err: any) => {
                this.onEnd();
            }));
    }

    private onEnd(): void {
        this.hideLoader();
    }

    private showLoader(displayCancel = false): void {
        this.spinnerService.show(displayCancel, null);
    }

    private hideLoader(): void {
        this.spinnerService.hide();
    }
}
